import React from 'react';

/**
 * SelectionHeader — replaces ChatHeader when the user is in multi-select mode.
 * Shows the count of selected messages and a bulk-delete trash button.
 */
const SelectionHeader = ({ selectedCount, onExit, onDelete }) => (
  <div className="flex items-center justify-between px-4 py-3 bg-blue-50 border-b border-blue-200 animate-chatFadeIn">
    <div className="flex items-center gap-3">
      <button onClick={onExit} className="p-1 hover:bg-blue-100 rounded-full transition-colors">
        <svg className="w-6 h-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      <span className="font-semibold text-blue-900">{selectedCount} Selected</span>
    </div>
    <button
      onClick={onDelete}
      disabled={selectedCount < 2}
      className="p-2 bg-red-50 hover:bg-red-100 disabled:opacity-40 rounded-full transition-all text-red-600 active:scale-95"
      title="Delete selected"
    >
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
      </svg>
    </button>
  </div>
);

export default SelectionHeader;
